import { render, staticRenderFns } from "./serveContent.vue?vue&type=template&id=52be238a&scoped=true&"
import script from "./serveContent.vue?vue&type=script&lang=js&"
export * from "./serveContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be238a",
  null
  
)

export default component.exports